// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"b9146a83","136":"b9146a83","178":"73283106","312":"070131dc","715":"367cbc49","945":"c3f353c7","987":"c4be858c"}[chunkId] + ".chunk.css";
};